import { IUserResponse } from 'interfaces/user';
import axios, { Response } from 'services';

export const getProfileData = (): Response<IUserResponse> => {
	return axios.get(`/profile`);
};

export interface IProfileRequest {
	first_name?: string;
	last_name?: string;
	middle_name?: string;
	phone?: string;
};
export const changeProfileData = (profileData: IProfileRequest): Response<void> => {
	return axios.patch(`/profile`, profileData);
};

export interface IWalletResponse {
	balanceSum: string;
};
export const getWalletData = (): Response<IWalletResponse> => {
	return axios.get(`/profile/wallet`);
};

export interface IPasswordRequest {
	password: string;
	confirmPassword: string;
};
export const changePassword = (passwordData: IPasswordRequest): Response<void> => {
	const payload = {
		password: passwordData.password,
		password_confirmation: passwordData.confirmPassword,
	}
	return axios.patch(`/profile/update_password`, payload);
};